<template>      
  <div class="wrapper">
    <div class="container">
      <md-card class="customCard navbar-margin">
        <md-card-content>
          <div class="md-layout">
            <div class="md-layout-item">
              <div class="tim-typo">
                <h2 class="title">Veranstaltungen</h2> 
                <p>Hier finden sie bevorstehende Veranstaltungen, bei denen wir gerne in ein pers&ouml;nliches Gespr&auml;ch kommen k&ouml;nnen.</p>
              </div>
              <div class="grid-container">
                <div class="container" v-for="event in events" :key="event.id">
                  <md-card class="partnerCard z-depth-1">
                    <md-card-content>
                      <h5 style="font-weight: bold;"><span class="material-icons contactIcon">event_available</span>{{event.title}}</h5>
                      <p><span class="material-icons contactIcon">place</span>{{event.address1}}</p>
                      <p v-if="event.address2 !== null">{{event.address2}}</p>
                      <p><span class="material-icons contactIcon">date_range</span>{{event.date}}</p>
                      <p v-if="event.time !== null"><span class="material-icons contactIcon">access_time</span>{{event.time}}</p>
                    </md-card-content>
                  </md-card>
                </div>
              </div>
            </div>
          </div>
        </md-card-content>
      </md-card>
    </div>
  </div>
</template>

<script>
import events from '@/components/events.json';

export default {
  name: 'Veranstaltungen',
  props: {
    msg: String
  },
  data() {
    return {
      events
    }
  },
  methods: {
    onResponsiveInverted() {
      if (window.innerWidth < 600) {
        this.responsive = true;
      } else {
        this.responsive = false;
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
